<template>
  <el-carousel :interval="5000" height="42.7vw">
    <el-carousel-item v-for="item in carousel" :key="item.id">
      <div class="inside">

      <img
        :src="item.image"
        alt=""
      />
      <p>{{item.name}}</p>
      <p>{{item.description}}</p>
      </div>
    </el-carousel-item>
  </el-carousel>
</template>

<script>
export default {
  name: "carousel",
  data() {
    return {
      carousel: [],
    };
  },
  created() {
    this.$api.AD(3).then((res) => {
      // this.$public_data.imageURL(res).then((res) => {
        this.carousel.push(...res);
      // });
    });
  },
};
</script>

<style lang='less' scoped>
.inside{
  font-size: 2.4vw;
  font-weight: bold;
  color: #fff;
  p{
    position: absolute;
    top: 21.67vw;
    left: 56vw;
  }
  >p:last-child{
    top: 26.04vw;
    left: 60vw;
  }
}
// .carousel {
img {
  width: 100%;
  height: 100%;
}
// }

// .el-carousel__item:nth-child(2n) {
//   background-color: #99a9bf;
// }

// .el-carousel__item:nth-child(2n + 1) {
//   background-color: #d3dce6;
// }
</style>


// WEBPACK FOOTER //
// src/components/common/carousel.vue